import React, { useEffect, useRef, useState } from "react";
import "../../App.css";
import Carousel from "react-bootstrap/Carousel";
import img_acceuil from "../../assets/img/image_tp.jpg";
import img_acceuil1 from "../../assets/img/back_sansplan_2.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import CustomModal from "./CustomModal";
import commite from "../../assets/video/open.mp4";

export default function Header() {
  const item = [
    {
      img:img_acceuil ,
      caption: {
        fr: {
          heading: "BIENVENUE A LA PREMIERE ECOLE CANADIENNE",
          subheading: " Cours individuels - en Groupe - en Ligne ou en Présentiel (Jour/nuit)",
          cta: "Pourquoi Étudier Chez Nous",
        },
        en: {
          heading: "WELCOME TO FIRST CANADIAN INTERNATIONAL SCHOOL",
          subheading: "Day, evening and online classes",
          cta: "Why Study With Us",
        },
      },
    },
    {
      img: img_acceuil1,
      caption: {
        fr: {
          heading: "BIENVENUE A LA PREMIERE ECOLE CANADIENNE",
          subheading: " Cours individuels - en Groupe - en Ligne ou en Présentiel (Jour/nuit)",
          cta: "Pourquoi Étudier Chez Nous",
        },
        en: {
          heading: "WELCOME TO FIRST CANADIAN INTERNATIONAL SCHOOL",
          subheading: "Day, evening and online classes",
          cta: "Why Study With Us",
        },
      },
    },
    {
      img: "https://th.bing.com/th/id/R.c6340b2e265e8e4c19d2e9cd65407dc0?rik=O1GRhGh0H1kVpw&riu=http%3a%2f%2fatlantablackstar.com%2fwp-content%2fuploads%2f2014%2f01%2fIMG_2996-e1338848446416.jpg&ehk=biQALH4ig6vXZLUvXd0Ky%2fS%2brqrFgBXE6IGY%2fA33hSE%3d&risl=&pid=ImgRaw&r=0",
      caption: {
        fr: {
          heading: "BIENVENUE A LA PREMIERE ECOLE CANADIENNE",
          subheading: " Cours individuels - en Groupe - en Ligne ou en Présentiel (Jour/nuit)",
          cta: "Pourquoi Étudier Chez Nous",
        },
        en: {
          heading: "WELCOME TO FIRST CANADIAN INTERNATIONAL SCHOOL",
          subheading: "Day, evening and online classes",
          cta: "Why Study With Us",
        },
      },
    },
    
  ];

  const [isOpen, setIsOpen] = useState(false);
  const videoRef = useRef(null);

  // Ouvre le modal
  const openModal = () => {
    setIsOpen(true);
  };

  // Démarrer la vidéo avec le son lorsque le modal est ouvert
  useEffect(() => {
    if (isOpen && videoRef.current) {
      const videoElement = videoRef.current;
      videoElement.muted = false; // Désactiver le mode muet
      videoElement.play().catch((error) => {
        console.warn("Lecture automatique refusée", error);
      });
    }
  }, [isOpen]);

  // UseEffect pour ouvrir le modal automatiquement au chargement de la page
  useEffect(() => {
    openModal(); // Ouvrir le modal dès le chargement
  }, []); // Ce useEffect ne se déclenche qu'une seule fois lors du premier rendu

  const closeModal = () => setIsOpen(false);

  return (
    <>
      <Carousel
        as="div"
        indicators={true}
        interval={3000}
        keyboard={false}
        wrap={true}
        controls={false}
        fade
      >
        {item.map((item, index) => (
          <Carousel.Item key={index}>
            <img
              className="d-block w-100"
              src={item.img}
              alt={`Slide ${index + 1}`}
            />
            <Carousel.Caption>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "left",
                  marginBottom: "0.7rem",
                }}
              >
                <h1
                  className="text-left h1"
                  style={{
                    color: index === 0 ? "#fff" : index === 1 ? "#fff" : "#fff",
                  }}
                >
                  BIENVENUE A LA <br /> PREMIERE ECOLE <br /> CANADIENNE
                </h1>
                <div
                  style={{
                    height: "8rem",
                    width: "2px",
                    backgroundColor: "#fff",
                    margin: "0 1rem",
                  }}
                ></div>
                <h1
                  className="text-left h1"
                  style={{
                    color:
                      index === 0 ? "#fff" : index === 1 ? "#f1f1f1" : "#fff",
                  }}
                >
                  WELCOME TO FIRST <br /> CANADIAN <br /> INTERNATIONAL SCHOOL
                </h1>
              </div>
              <p
                className="p"
                style={{
                  color: index === 0 ? "#fff" : index === 1 ? "#fff" : "#fff",
                }}
              >
                 Cours individuels - en Groupe - en Ligne ou en Présentiel (Jour/nuit)
              </p>
              <button
                id="cta"
                onClick={openModal}
                disabled={false}
                className="btn bg-white animated-btn"
                style={{
                  textDecoration: "none",
                  border: "none",
                  padding: "0.75rem 1.5rem",
                  fontSize: "1.1rem",
                  borderRadius: "25px",
                  cursor: "pointer",
                  transition: "background-color 0.3s ease, transform 0.2s ease",
                  boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                  gap: "0.5rem",
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                  overflow: "hidden",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f1f1f1";
                  e.target.style.transform = "scale(1.1)";
                  e.target.style.color = "#000";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "white";
                  e.target.style.transform = "scale(1)";
                  e.target.style.color = "inherit";
                }}
              >
                Regarder la Vidéo d'Actualité
                <FontAwesomeIcon icon={faChevronRight} className="mx-2" />
                {/* Outline pulsant */}
                <span className="pulsing-outline"></span>
              </button>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>

      <CustomModal
        isOpen={isOpen}
        onRequestClose={closeModal}
        title=""
        taille="lg"
      >
        <div className="embed-responsive embed-responsive-16by9">
          <video
            ref={videoRef}
            src={commite}
            controls
            autoPlay
            loop
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </div>
      </CustomModal>
    </>
  );
}
